<template>
  <div class="registeredDetails-box">
    <div class="doctor-hint">
      <div class="doctor-img">
        <img src="~@/assets/images/doctor.png">
      </div>
      <div>
        <div class="name">{{ list[0] && list[0].doctorName || '——' }}</div>
        <div class="title">职称：{{ list[0] && list[0].doctorTitle || '——' }}</div>
      </div>
    </div>
    <van-tabs v-model="activeName">
      <van-tab title="挂号" name="gauHao">
        <template>
          <!-- <van-cell :title="date" value="更多日期" @click="show = !show">
            <van-icon class="date-icon" v-if="show" slot="right-icon" name="arrow" color="#999"/>
            <van-icon class="date-icon" v-if="!show" slot="right-icon" name="arrow-down" color="#999"/>
          </van-cell> -->

          <!-- <week ref="week" v-if="!show" v-model="date" :week-status="weekStatus"></week> -->
          <van-cell :title="date" />
          <time-cell :list="list" />
        </template>
      </van-tab>
      <van-tab title="介绍" name="jieShao">
        <van-cell-group style="white-space: pre-wrap">
          <!-- <van-cell title="专业特长" :label="list[0] && list[0].doctorGood || '暂无'" /> -->
          <van-cell title="个人介绍" :label="list[0] && list[0].doctorIntroduce || '暂无'" />
        </van-cell-group>
      </van-tab>
    </van-tabs>
    <van-loading v-if="loading" />
  </div>
</template>

<script>
import TimeCell from './components/timeCell'
// import Week from '../../components/week'
export default {
  name: 'RegisteredDetails',
  components: {
    //  Week,
    TimeCell
  },
  data() {
    return {
      list: [],
      doctorCode: '',
      doctorId: '',
      deptId: '',
      date: '',
      timeID: '',
      show: false,
      loading: false,
      isGet: false,
      activeName: 'guaHao'
      // weekStatus: {}
    }
  },
  watch: {
    // date (val) {
    //   const self = this
    //   setTimeout(function () {
    //     if (self.isGet) {
    //       self.getDoctorKeepList()
    //     }
    //   })
    // }
  },
  created() {
    const { doctorCode, deptCode, time, noon } = this.$route.query
    this.doctorCode = doctorCode
    this.deptCode = deptCode
    // const tempTime = time.split('/')
    // if (tempTime[1] < 10) {
    //   this.date = `${tempTime[0]}-0${tempTime[1]}-${tempTime[2]}`
    // } else {
    //   this.date = `${tempTime[0]}-${tempTime[1]}-${tempTime[2]}`
    // }
    this.date = time
    this.timeID = noon
  },
  mounted() {
    this.$nextTick(function() {
      // this.getKeepRangeFun()
      this.getDoctorKeepList()
    })
  },
  methods: {
    getDoctorKeepList() {
      const parms = {
        day: this.date,
        deptCode: '',
        doctorCode: this.doctorCode,
        timeID: this.timeID ? String(this.timeID) : ''
      }
      this.loading = true
      this.list = []
      this.$Apis.getKeep(parms).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.list = res.data
        } else {
          this.list = []
        }
      }).catch(() => {
        this.loading = false
        this.list = []
      })
    }

    // getKeepRangeFun() {
    //   this.$Apis.getKeepRange({
    //     deptCode: this.deptCode,
    //     doctorCode: this.doctorCode,
    //     endDate: this.$refs.week.weekDay[13].name,
    //     startDate: this.$refs.week.weekDay[0].name
    //   }).then(res => {
    //     this.isGet = true
    //     if (res.code === 200) {
    //       this.weekStatus = res.data
    //       if (!this.date) {
    //         this.date = Object.keys(this.weekStatus)[0]
    //       }
    //     } else {
    //       this.$notify.danger('系统出错请稍后再试')
    //     }

    //     this.getDoctorKeepList()
    //   })
    // }
  }
}
</script>

<style scoped lang="less">
  /deep/.van-loading{
    margin-top: 1rem;
    text-align: center;
  }
  .doctor-hint {
    display: flex;
    background-color: #fff;
    padding: 25px;
    align-items: center;
    .name {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .title {
      color: #9D9D9D;
    }
  }

  .jie-shao {
    background-color: #fff;
    padding: 25px;
    .jie-shao-title {
      font-size: 16px;
      margin-bottom: 5px;
    }

    .jie-shao-content {
      color: #9D9D9D;
    }
  }

  .doctor-img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
    > img {
      width: 50px;
      height: 50px;
    }
  }

  .date-icon {
    line-height: inherit;
    margin-left: 10px;
  }
</style>
<style lang="less">
  .van-tabs__content {
    margin-top: 10px;
  }
</style>
